import { ConfigService } from '@/configServices';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@services/app.service';
import { gsap } from 'gsap';
import CSSRulePlugin from 'gsap/CSSRulePlugin';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AddCertificateDetails } from '@/model/certificateDetails/add-certificate-details';
import html2canvas from 'html2canvas';
import QRCode from 'qrcode-generator';

gsap.registerPlugin(CSSRulePlugin);

@Component({
  selector: 'app-certificate-view',
  templateUrl: './certificate-view.component.html',
  styleUrls: ['./certificate-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CertificateViewComponent implements OnInit {
  destroy$: Subject<boolean> = new Subject<boolean>();
   @ViewChild('certificate') certificateRef!: ElementRef;
  certificateDetails: AddCertificateDetails;
  certificateId : string = "";
  qrCodeImage!: string;
  isQrFlow: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private appService: AppService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private configService: ConfigService,
    private http: HttpClient,
    private router : Router
  ) { }

  ngOnInit(): void {
    // 1️⃣ Customer flow (QR scan)
  const queryCid = this.route.snapshot.queryParamMap.get('cid');

  if (queryCid) {
    this.certificateId = atob(queryCid); // decode
    this.isQrFlow = true;
  }
  // 2️⃣ Admin flow
  else {
    this.certificateId = atob(localStorage.getItem('certificateId')!);
  }
    this.getByCertificateIdDetails();
    this.generateQrCode(this.certificateId);
  }

  getByCertificateIdDetails(){
    this.spinner.show();
    this.appService.getByCertificateIdDetails(this.certificateId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        this.spinner.hide();
        this.certificateDetails = data;
        if(!this.isQrFlow){
        setTimeout(() => {
          this.downloadCertificate();
        },400)
        }
      }, (error: any) => {
        this.spinner.hide();
        this.toastr.error(error.message || "Something Went Wrong,Please Try Again...")
      })
  }
  

downloadCertificate() {
  const element = this.certificateRef.nativeElement;

  html2canvas(element, {
    scale: 4, // Higher scale = better quality (you can try 3–5)
    useCORS: true, // Enables cross-origin images (important if you have logos)
    logging: false,
    backgroundColor: '#ffffff', // Ensures white background (optional)
  }).then((canvas) => {
    // Convert to PNG for better quality
    const link = document.createElement('a');
    link.href = canvas.toDataURL('image/png', 1.0); // PNG = lossless
    link.download = 'certificate.png';
    link.click();

    this.toastr.success('Certificate Downloaded Successfully!');
    this.spinner.hide();
    this.router.navigate(['/main/admin-certificate-list-table']);
  });
}

ngOnDestroy(): void {
  localStorage.removeItem('certificateId');
}

generateQrCode(certificateId: string) {
  const protocol = window.location.protocol;
  const host = window.location.host;

  const encodedId = btoa(certificateId);
  const qrValue = `${protocol}//${host}/#/certificate-view?cid=${encodedId}`;

  const qr = QRCode(0, 'M');
  qr.addData(qrValue);
  qr.make();

  this.qrCodeImage = qr.createDataURL(6);
}
 
}
